import api from "./http";
import { API_ENDPOINTS } from "./endpoints";

export async function fetchPlans() {
  const res = await api.get(API_ENDPOINTS.PLANS);
  return res;
}
